import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92ec9954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-style" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      name: "toggle",
      checked: _ctx.value,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('change', $event)))
    }, null, 40, _hoisted_2),
    _hoisted_3
  ]))
}